<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-08-26 10:50:45
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-08-26 15:12:59
 * @FilePath: \ces-vue-serve\src\views\assistantContractList\assistantContractList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="ChiefList">
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="合同查询">
        <contractQuery />
      </rj-tab-pane>
      <!-- 销售新增 -->
      <rj-tab-pane v-if="asSale" name="6" label="退换货合同查询">
        <returnReplacementContractSale />
      </rj-tab-pane>
      <!-- 新增结束 -->
      <rj-tab-pane v-if="!hideCompony.includes($store.state.user.userId) && !asSale" name="2" label="分批发货查询">
        <partialContractQuery />
      </rj-tab-pane>
      <rj-tab-pane v-if="!hideCompony.includes($store.state.user.userId) && !asSale" name="3" label="已发货订单查询">
        <shippedContractQuery />
      </rj-tab-pane>
      <rj-tab-pane v-if="!hideCompony.includes($store.state.user.userId) && !asSale" name="4" label="交期查询">
        <deliveryDateQuery />
      </rj-tab-pane>
      <rj-tab-pane v-if="!hideCompony.includes($store.state.user.userId) && !asSale" name="6" label="退换货合同查询">
        <returnReplacementContract />
      </rj-tab-pane>
      <rj-tab-pane v-if="!hideCompony.includes($store.state.user.userId) && !asSale" name="5" label="对账单查询">
        <selectManagement />
      </rj-tab-pane>
      <rj-tab-pane v-if="!hideCompony.includes($store.state.user.userId) && !asSale" name="7" label="已申请提前开票">
        <advanceMake />
      </rj-tab-pane>
      <rj-tab-pane v-if="!hideCompony.includes($store.state.user.userId) && !asSale" name="8" label="已申请发货单">
        <appliedInvoice />
      </rj-tab-pane>
      <rj-tab-pane v-if="!hideCompony.includes($store.state.user.userId) && !asSale" name="9" label="待付款发货单">
        <obligationInvoice />
      </rj-tab-pane>

      <!-- <rj-tab-pane name="7" label="认款错误审核" v-if="!this.$store.state.enumeration.hideCompony.includes(this.$store.state.user.userId) &&!this.$store.state.user.asSale">
        <payment-error-audit />
      </rj-tab-pane> -->
      <!--撤销分配记录查询-->
      <rj-tab-pane v-if="!hideCompony.includes($store.state.user.userId) && !asSale" name="10" label="撤销分配记录查询">
        <view-revocation-records :tabs-active="tabsActive" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import contractQuery from './contractQuery';
import partialContractQuery from './partialContractQuery';
import shippedContractQuery from './shippedContractQuery';
import deliveryDateQuery from './deliveryDateQuery';
import selectManagement from './selectManagement';
import returnReplacementContract from './return-replacement-contract/index.vue';
import returnReplacementContractSale from './return-replacement-contract/indexSale.vue';
// 提前开票
import advanceMake from './advanceMake.vue';
// 已申请发货单
import appliedInvoice from './appliedInvoice';
// 代付款发货单
import obligationInvoice from './obligationInvoice';
import ViewRevocationRecords from '@/views/assistantContractList/ViewRevocationRecords.vue';

// import paymentErrorAudit from './paymentErrorAudit.vue';

export default {
  name: 'AssistantContractList',
  components: {
    ViewRevocationRecords,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    contractQuery,
    partialContractQuery,
    shippedContractQuery,
    deliveryDateQuery,
    selectManagement,
    advanceMake,
    returnReplacementContract,
    returnReplacementContractSale,
    appliedInvoice,
    obligationInvoice
    // paymentErrorAudit
  },

  data () {
    return {
      hide: true
      // tabsActive: '1'
    };
  },

  computed: {
    ...mapState({
      asSale: state => state.user.asSale,
      hideCompony: state => state.enumeration.hideCompony
    }),
    tabsActive: {
      get () {
        return this.$store.state.pagesTemporary.AssistantContractList;
      },
      set (val) {
        this.$store.commit('pagesTemporary/SETassistantContractList', val);
      }
    }
  }
};
</script>
